import { Box, Tag, Text } from "@seneca/senekit";

type Props = {
  numOfQuestionsToStudy: number;
  numOfQuestionsAssigned: number;
  width?: string;
};

export default function ExamQuestionsCount({
  width,
  numOfQuestionsToStudy,
  numOfQuestionsAssigned
}: Props) {
  const hasQuestionsToStudy = numOfQuestionsToStudy > 0;

  const count = hasQuestionsToStudy
    ? numOfQuestionsToStudy
    : numOfQuestionsAssigned;

  return (
    <Box
      width={width}
      paddingY="small"
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <Box paddingRight="medium">
        <Text size="small">Exam Questions</Text>
      </Box>
      <Tag
        tone={hasQuestionsToStudy ? "primary" : "neutral"}
        size="xsmall"
        strength="weak"
      >
        {count}
      </Tag>
    </Box>
  );
}
